<template>
    <o-modal name="dashboardCalendarModal">
        <template slot="content">
            <div
                v-if="delivery && delivery.length > 0 && deliveryStatus !== 'pending'"
                class="l-container o-dashboardCalendarModal"
            >
                <div class="o-dashboardCalendarModal__header">
                    <div>
                        <p
                            class="a-text a-text--green a-text--bold o-dashboardCalendarModal__text o-dashboardCalendarModal__text--big"
                        >
                            {{ deliveryInfo.status }}
                            {{ moment(deliveryInfo.date).format('DD.MM.YYYY') }}
                        </p>
                        <!-- <p class="a-text a-text--green">
                            o godzinie <span class="a-text--bold">12:34</span>
                        </p> -->
                    </div>
                    <div class="o-dashboardCalendarModal__details">
                        <div>
                            <p class="a-control__label a-label">
                                Adres dostawy
                            </p>
                            <p class="a-text o-dashboardCalendarModal__text">
                                {{ deliveryInfo.client_name }}<br />
                                {{ deliveryInfo.address }}
                            </p>
                        </div>
                        <div v-if="deliveryInfo.supplier">
                            <p class="a-control__label a-label">
                                Kontakt z kurierem
                            </p>
                            <p class="a-text">
                                {{ deliveryInfo.supplier.full_name }}<br />
                                tel.:
                                <a
                                    class="o-dashboardCalendarModal__phone"
                                    :href="`tel:${deliveryInfo.supplier.phone}`"
                                    >{{ deliveryInfo.supplier.phone }}</a
                                >
                            </p>
                        </div>
                    </div>

                </div>
                <hr class="o-dashboardCalendarModal__divider" />
                <div class="o-dashboardCalendarModal__orderList">
                    <template v-for="deliveryElem in delivery">
                        <div
                            v-for="deliveryItem in deliveryElem.deliveries"
                            class="o-dashboardCalendarModal__orderItem"
                            :key="deliveryItem.id"
                        >
                            <div
                                class="o-dashboardCalendarModal__orderItemHeader"
                            >
                                <p
                                    class="a-text o-dashboardCalendarModal__text o-dashboardCalendarModal__text--big"
                                >
                                    Zamówienie #{{ deliveryItem.id }}
                                </p>
                                <p
                                    class="a-text a-text--big o-dashboardCalendarModal__orderItemFrequency"
                                >
                                    {{ deliveryItem.severed ? periods.find(period => period.id === 0).name : deliveryElem.cycle }}
                                </p>

                                <div
                                    class="o-dashboardCalendarModal__cancelOrderButtonWrapper"
                                >
                                    <button
                                        v-if="deliveryItem.supplied"
                                        class="a-button  o-dashboardCalendarModal__button"
                                        :class="{
                                            'o-dashboardCalendarModal__button--active': isReported
                                        }"
                                        @click="showComplaint = !showComplaint"
                                        :key="deliveryItem.id"
                                    >
                                        <span
                                            v-if="
                                                complaintStatus === 'reported'
                                            "
                                            class="o-dashboardCalendarModal__button-text"
                                        >
                                            Zgłoszono reklamcję<br />
                                            <a
                                                href="#"
                                                class="a-link a-text--bold"
                                                >Zobacz szczegóły</a
                                            >
                                        </span>
                                        <span
                                            v-else
                                            class="o-dashboardCalendarModal__button-text"
                                        >
                                            {{
                                                showComplaint
                                                    ? 'Ukryj formularz reklamacji'
                                                    : 'Zgłoś reklamację'
                                            }}
                                        </span>
                                        <!-- <a-icon icon="ExclamationRed" /> -->
                                    </button>
                                    <button
                                        v-if="
                                            !deliveryItem.supplied &&
                                                cancelStatus !== 'pending' &&
                                                !deliveryItem.cancelDeliveryClicked
                                        "
                                        class="a-button o-dashboardCalendarModal__button o-dashboardCalendarModal__button--red"
                                        @click="
                                            confirmCancelDelivery(deliveryItem)
                                        "
                                    >
                                        <span
                                            class="o-dashboardCalendarModal__button-text"
                                        >
                                            Odwołaj dostawę
                                        </span>
                                        <a-icon icon="Exclamation" />
                                    </button>
                                    <button
                                        v-if="
                                            deliveryItem.cancelDeliveryClicked
                                                ? true
                                                : ''
                                        "
                                        class="a-button a-button--secondary o-dashboardCalendarModal__button"
                                        :class="{
                                            'a-button--disabled': errorMessage
                                        }"
                                        @click="cancelDelivery(deliveryItem.id)"
                                        :disabled="cancelDeliveryButtonDisabled"
                                    >
                                        <template
                                            v-if="cancelDeliveryButtonDisabled"
                                            >{{
                                                confirmCancelDeliveryText
                                            }}</template
                                        >
                                        <template
                                            v-if="
                                                confirmCancelDeliveryCountdown >=
                                                    0
                                            "
                                        >
                                            ...{{
                                                confirmCancelDeliveryCountdown
                                            }}</template
                                        >
                                        <template v-else>{{
                                            confirmCancelDeliveryCountdown
                                        }}</template>
                                    </button>
                                    <div
                                        v-if="
                                            !deliveryItem.supplied &&
                                                cancelStatus === 'pending'
                                        "
                                    >
                                        <a-icon icon="SpinnerSmall" />
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="showComplaint"
                                class="o-dashboardCalendarModal__complaints"
                            >
                                <a-control
                                    class="o-dashboardCalendarModal__complaintsInput"
                                    label="Dodaj reklamację"
                                    type="textarea"
                                    v-model="complaintContent"
                                    id="complaintContent"
                                />
                                <br />
                                <p class="a-control__label a-label">
                                    Dodaj załącznik
                                </p>
                                <input
                                    type="file"
                                    ref="files"
                                    multiple
                                    @change="complaintFiles = $event.target.files"
                                />
                                <br />
                                <a-button
                                    class="a-button a-button--secondaryInvert"
                                    @click="handleSubmitComplain(deliveryItem.id)"
                                    :is-processing="complaintStatus === 'pending'"
                                    >Zgłoś reklamację</a-button
                                >
                            </div>
                            <o-notifications :is-static="true" name="complaint" />
                            <div
                                v-if="deliveryItem.packages"
                                class="o-dashboardCalendarModal__products"
                            >
                                <div
                                    class="o-dashboardCalendarModal__product"
                                    v-for="pack in deliveryItem.packages"
                                    v-bind:key="pack.id"
                                >
                                    <div
                                        class="o-dashboardCalendarModal__column o-dashboardCalendarModal__column--left"
                                    >
                                        <img
                                            v-if="pack.image_url"
                                            :src="`${apiUrl}${pack.image_url}`"
                                            :alt="pack.name"
                                            class="o-dashboardCalendarModal__image"
                                        />
                                        <img
                                            v-else
                                            src="@/assets/pack.jpg"
                                            :alt="pack.name"
                                            class="o-dashboardCalendarModal__image"
                                        />
                                    </div>
                                    <div
                                        class="o-dashboardCalendarModal__column o-dashboardCalendarModal__column--center"
                                    >
                                        <p
                                            class="a-text a-text--bold o-dashboardCalendarModal__productTitle"
                                        >
                                            {{ pack.name }}
                                        </p>
                                    </div>

                                    <div
                                        class="l-container o-dashboardCalendarModal__column o-dashboardCalendarModal__column--right"
                                    >
                                        <div class="l-row__column">
                                            <div class="l-row ">
                                                <div
                                                    class="l-row__column --padding-0 o-dashboardCalendarModal__actionControls"
                                                >
                                                    <span
                                                        v-if="!deliveryItem.is_restricted"
                                                        :style="
                                                            pack.amount >
                                                            getInitalAmount(
                                                                pack
                                                            )
                                                                ? 'visibility: visible'
                                                                : 'visibility: hidden'
                                                        "
                                                        class="material-icons m-product__button m-product__subtract"
                                                        @click="subtract(pack)"
                                                        >remove</span
                                                    >
                                                    <span
                                                        class="a-text a-text--green o-dashboardCalendarModal__text"
                                                        >{{
                                                            pack.amount
                                                        }}
                                                        szt.</span
                                                    >
                                                    <span
                                                        v-if="!deliveryItem.is_restricted"
                                                        class="material-icons m-product__button m-product__add"
                                                        @click.once="
                                                            saveInitAmount(pack)
                                                        "
                                                        @click="
                                                            add(pack),
                                                                addProd(pack)
                                                        "
                                                        >add</span
                                                    >
                                                </div>
                                            </div>
                                            <div class="l-row">
                                                <div
                                                    class="l-row__column --padding-0"
                                                >
                                                    <p class="a-text">
                                                        <span
                                                            class="a-text--big"
                                                            >{{
                                                                pack.net_price
                                                            }}
                                                            /
                                                            {{
                                                                (
                                                                    pack.net_price *
                                                                    pack.amount
                                                                ).toFixed(2)
                                                            }}&nbsp;PLN</span
                                                        >
                                                        <br />
                                                        cena / wartość
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="l-container o-dashboardCalendarModal__orderItemFooter"
                            >
                                <div class="l-row">
                                    <div class="l-row__column l-row__column--4">
                                        <button
                                            v-if="deliveryItem.upsell_allowed"
                                            class="a-button a-button o-dashboardCalendarModal__button"
                                            @click="
                                                toggleActiveUpsellModule(
                                                    deliveryItem, $event
                                                )
                                            "
                                        >
                                            Dodaj produkt do zamówienia
                                        </button>
                                    </div>
                                    <div class="l-row__column l-row__column--5">
                                        <div
                                            v-if="activeUpsellModuleId === deliveryItem.id && upsellProductsStatus && upsellProductsErrorMessage"
                                            class="o-dashboardCalendarModal__notificationsWrapper"
                                        >
                                            <p
                                                class="a-text o-dashboardCalendarModal__notificationText"
                                            >
                                                {{ upsellProductsErrorMessage }}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        class="l-row__column l-row__column--3 --paddingTop-0"
                                    >
                                        <p
                                            class="a-price a-price--big a-price--bold a-price--center"
                                        >
                                            {{ deliveryItem.net_price.toFixed(2) }} PLN
                                        </p>
                                        <label v-if="!deliveryItem.severed && deliveryElem.not_single" for="cycle"> Stała zmiana cyklu
                                            <input @click="changeCycle(deliveryItem, $event)" type="checkbox" name="cycle">
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">

                                <div
                                    v-if="activeUpsellModuleId === deliveryItem.id && deliveryItem.upsell_allowed"
                                    class="o-dashboardCalendarModal__upsellModule"
                                >
                                    <div v-if="weekOrders.length > 0" class="o-dashboardCalendarModal__cart ">
                                        <div class="o-dashboardCalendarModal__cartHeader">
                                            <p class="a-text a-text--big a-text--bold">Nowe produkty</p>
                                            <p class="a-text">
                                                Zamówienie na
                                                <b>{{ dayInWeek.toDay() }}</b
                                                >, suma:
                                                <b>{{ weekDayOrderSum.toPLN() }}</b>
                                            </p>
                                        </div>
                                        <div class="o-dashboardCalendarModal__cartList">
                                            <product-box
                                                v-for="product in weekOrders"
                                                :key="product.id"
                                                :product="product.product"
                                                :day-in-week="dayInWeek"
                                                :address-id="addressId * -1"
                                                :show-in-modal="true"
                                                :show-buttons="true"
                                                :noOverlay="false"
                                            />
                                        </div>
                                        <button
                                            class="a-button a-button--primary o-dashboardCalendarModal__cartListButton"
                                            @click="addProductsToUpsell(deliveryItem)"
                                        >
                                            Dodaj
                                        </button>
                                    </div>

                                        <products-list
                                            v-if="
                                                activeUpsellModuleId === deliveryItem.id
                                            "
                                            :day-in-week="dayInWeek"
                                            :address-id="addressId * -1"
                                            :upsell="true"
                                            :show-buttons="false"
                                            :is-one-time-order="deliveryElem.not_single"
                                        />

                                </div>
                            </transition>
                            <hr class="o-dashboardCalendarModal__divider" />
                        </div>

                    </template>
                </div>
                <div
                    v-if="
                        delivery.supplier &&
                            delivery.supplier.latitude &&
                            delivery.supplier.longitude
                    "
                    class="o-dashboardCalendarModal__map"
                >
                    <br /><br />
                    <p class="a-control__label a-label">
                        Gdzie jest kurier
                    </p>
                    <div class="o-dashboardCalendarModal__mapContainer">
                        <GmapMap
                            if="mapDiv"
                            class="a-control__map"
                            :center="{
                                lat: +delivery.supplier.latitude,
                                lng: +delivery.supplier.longitude
                            }"
                            :zoom="15"
                            map-type-id="terrain"
                            ref="gmap"
                        >
                            <GmapMarker
                                :position="{
                                    lat: +delivery.supplier.latitude,
                                    lng: +delivery.supplier.longitude
                                }"
                                :draggable="false"
                            />
                        </GmapMap>
                    </div>
                </div>
                <div class="l-container o-dashboardCalendarModal__footer">
                    <div class="l-row__column">
                        <div class="l-row">
                            <div
                                v-if="upsellStatus === 'error'"
                                class="o-dashboardCalendarModal__notificationsWrapper"
                            >
                                <a-icon
                                    icon="ExclamationRed"
                                    class="o-dashboardCalendarModal__notificationIcon"
                                />
                                <p
                                    class="a-text o-dashboardCalendarModal__notificationText"
                                >
                                    {{ upsellErrorMessage }}
                                </p>
                            </div>
                            <div
                                v-if="errorMessage"
                                class="o-dashboardCalendarModal__notificationsWrapper"
                            >
                                <a-icon
                                    icon="ExclamationRed"
                                    class="o-dashboardCalendarModal__notificationIcon"
                                />
                                <p
                                    class="a-text o-dashboardCalendarModal__notificationText"
                                >
                                    {{ cancelDeliveryErrorMessage }}
                                </p>
                            </div>
                        </div>
                        <div class="l-row">
                            <div
                                class="o-dashboardCalendarModal__buttonControls"
                                v-if="wasChanged"
                            >
                                <button class="a-button" @click="closeModal">
                                    Odrzuć zmiany
                                </button>
                                <button
                                    class="a-button a-button--primary"
                                    @click="submitChangeAmount()"
                                >
                                    Zatwierdź zmiany
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <a-icon icon="Spinner" />
            </div>
        </template>
    </o-modal>
</template>

<script>
import moment from 'moment'
import ProductsList from '@/components/ProductsList'
import ProductBox from '@/components/ProductBox.vue'
export default {
    components: {
        ProductsList,
        ProductBox
    },
    props: {
        // Address id has to be set to MINUS number
        // in order to calcluate correctly the price
        addressId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            activeUpsellModuleId: 0,
            upsellProductsArray: [],
            errorMessage: false,
            wasChanged: false,
            isReported: false,
            showComplaint: false,
            complaintContent: '',
            complaintFiles: [],
            cancelDeliveryClicked: false,
            cancelDeliveryButtonDisabled: false,
            confirmCancelDeliveryText: 'Na pewno?',
            confirmCancelDeliveryCountdown: 3,
            initialValueItem: [],
            initProducts: [],
            productsToChange: [],
            productsToSend: {
                id: 0,
                packages: []
            }
        }
    },
    watch: {
        modalPayload: {
            deep: true,
            handler() {
                this.fetchDelivery()
                this.showComplaint = false
                this.cancelDeliveryClicked = false
                this.confirmCancelDeliveryCountdown = 3
                this.errorMessage = false
                this.wasChanged = false
                this.initialValueItem = []
                this.$store.dispatch('deliveries/setUpsellStatus', 'inital')
                this.initProducts = []
                this.initProducts.push(this.delivery.packages)
                this.productsToChange = []
                this.activeUpsellModuleId = 0
                this.$store.dispatch('resetWeekCart')
                this.$store.dispatch('deliveries/setBeforeUpsell', {})
                this.$store.dispatch('deliveries/resetCycleToChange')
            }
        }
    },
    computed: {
        dayInWeek() {
            const day = moment(this.delivery[0].deliveries[Object.keys(this.delivery[0].deliveries)].date).day()
            return day - 1
        },
        apiUrl() {
            return `${process.env.VUE_APP_API}client/v2`
        },
        cancelStatusmodalStatus() {
            return this.$store.getters.modalStatus('dashboardContainer')
        },
        modalPayload() {
            return this.$store.getters.modalPayload || {}
        },
        delivery() {
            return this.$store.getters['deliveries/view']
        },
        deliveryInfo() {
            const deliveries = this.delivery[0].deliveries
            const deliveriesArray = Object.entries(this.delivery[0].deliveries)
            const firstDeliveryId = deliveriesArray[0][0]
            return deliveries[firstDeliveryId]
        },
        deliveryStatus() {
            return this.$store.getters['deliveries/viewStatus']
        },
        cancelStatus() {
            return this.$store.getters['deliveries/cancelStatus']
        },
        complaintStatus() {
            return this.$store.getters['complaints/status']
        },
        upsellErrorMessage() {
            return this.$store.getters['deliveries/upsellErrorMessage']
        },
        upsellStatus() {
            return this.$store.getters['deliveries/upsellStatus']
        },
        cancelDeliveryErrorMessage() {
            return this.$store.getters['deliveries/error']
        },
        upsellProductsStatus() {
            return this.$store.getters['deliveries/upsellProductsStatus']
        },
        upsellProductsErrorMessage() {
            return this.$store.getters['deliveries/upsellProductsErrorMessage']
        },
        weekOrders() {
            return this.$store.getters.weekOrders
        },
        weekDayOrderSum() {
            return this.$store.getters.weekDayOrderSum(
                this.dayInWeek,
                -this.addressId,
                true
            )
        },
        beforeUpsell() {
            return this.$store.getters['deliveries/beforeUpsell']
        },
        weekAmount() {
            return this.$store.getters['weekCart/weekAmount']
        },
        weekPrice() {
            return this.$store.getters.weekAmount(-this.addressId)
        },
        upsellProductsOrderId() {
            return this.$store.getters['deliveries/upsellProductsOrderId']
        },
        minimumDayValue() {
            return this.$store.getters.minimumDayValue(this.dayInWeek)
        },
        cycleToChange() {
            return this.$store.getters['deliveries/cycleToChange']
        },
        periods() {
            return this.$store.getters.periods
        }
    },
    methods: {
        changeCycle(item, event) {
            this.$store.dispatch('deliveries/setCycleToChange', { id: item.id, all_forward: event.target.checked })
        },
        addProductsToUpsell(order) {
            const allForwadId = (item) => {
                const cycle = this.cycleToChange.find(elem => elem.id === item.id)
                if (cycle) {
                    return cycle.all_forward
                } else {
                    return false
                }
            }
            const payload = {
                week_price: this.weekPrice + this.beforeUpsell.net_price,
                all_forward: allForwadId(order),
                delivery_id: this.upsellProductsOrderId,
                packages: [],
                settings: {
                    logistic_minimum: this.minimumDayValue,
                    base_net_price: this.beforeUpsell.base_net_price,
                    date: this.beforeUpsell.date
                },
                terms: [
                    {
                        symbol: 'string',
                        confirmed: true
                    }
                ]
            }
            this.weekOrders.map(elem => {
                const pack = {
                    id: elem.product.id,
                    amount: elem.amount,
                    unit_price: this.$store.getters.packagePrice(
                        elem.product.id,
                        this.dayInWeek,
                        -this.addressId
                    ),
                    isodow: this.dayInWeek + 1,
                    date_from: this.beforeUpsell.date,
                    checksum: elem.product.checksum
                }
                payload.packages.push(pack)
            })
            this.$store.dispatch('deliveries/upsellSendProducts', payload).then((res) => {
                if (res.status !== 200) {
                    console.log(res)
                } else {
                    this.closeModal()
                }
            })
        },
        verifyOrderBeforeUpsell(item) {
            return this.$store
                .dispatch('deliveries/verifyOrderBeforeUpsell', item)
        },
        async toggleActiveUpsellModule(item, $event) {
            if (this.activeUpsellModuleId !== item.id) {
                this.$store.dispatch('resetWeekCart')
                this.$store.dispatch('deliveries/setBeforeUpsell', {})
                await this.verifyOrderBeforeUpsell(item).then(() => {
                    this.activeUpsellModuleId = item.id
                    setTimeout(() => {
                        const upsellModule = document.querySelector('.o-dashboardCalendarModal__upsellModule')
                        upsellModule.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
                    }, 500)
                })
            } else {
                this.activeUpsellModuleId = 0
                this.$store.dispatch('resetWeekCart')
            }
        },
        getInitalAmount(item) {
            const result = this.initialValueItem.find(elem => {
                return elem.id === item.id
            })
            if (result !== undefined) {
                return result.value
            }
        },
        saveInitAmount(item) {
            this.initialValueItem.push({
                id: item.id,
                value: item.amount
            })
        },
        closeModal() {
            this.activeUpsellModuleId = 0
            this.productsToSend = {
                id: 0,
                packages: []
            }
            this.initialValueItem = []
            this.wasChanged = false
            this.$store.dispatch('deliveries/setUpsellStatus', 'inital')
            this.$store.dispatch('modalHide', this.name)
            this.errorMessage = false
        },
        add(item) {
            this.wasChanged = true
            item.amount++
        },
        addProd(product) {
            if (!this.productsToChange.find(elem => elem === product)) {
                this.productsToChange.push(product)
            }
        },
        subtract(item) {
            const initialAmount = this.getInitalAmount(item)
            if (item.amount > initialAmount) {
                this.wasChanged = true
                item.amount--
            }
            if (item.amount === initialAmount) {
                this.$store.dispatch('deliveries/setUpsellStatus', 'inital')
                item.amount = initialAmount

                // remove item from array when the amount dosn't change
                this.productsToChange = this.productsToChange.filter(
                    elem => elem !== item
                )
                // hide buttons when nothing was changed
                if (this.productsToChange.length === 0) {
                    this.wasChanged = false
                }
            }
        },
        remove(item) {
            item.amount = 0
        },
        submitChangeAmount() {
            this.productsToSend = []
            this.$store.dispatch('deliveries/setUpsellStatus', 'inital')
            const allForwadId = (item) => {
                const cycle = this.cycleToChange.find(elem => elem.id === item.delivery_id)
                if (cycle) {
                    return cycle.all_forward
                } else {
                    return false
                }
            }
            this.productsToChange.forEach(elem => {
                const item = {
                    id: elem.delivery_id,
                    all_forward: allForwadId(elem),
                    packages: [
                        {
                            id: elem.id,
                            before_amount: this.initialValueItem.find(it => {
                                const result = it.id === elem.id
                                return result
                            }).value,
                            after_amount: elem.amount,
                            checksum: elem.checksum
                        }
                    ]
                }
                if (
                    item.packages[0].before_amount !==
                    item.packages[0].after_amount
                ) {
                    this.productsToSend.push(item)
                }
            })
            this.$store
                .dispatch('deliveries/upsell', this.productsToSend)
                .then(() => {
                    if (this.upsellStatus !== 'error') {
                        this.closeModal()
                        this.productsToSend = {
                            id: 0,
                            packages: []
                        }
                        this.productsToChange = []
                        this.$store.dispatch('deliveries/resetCycleToChange')
                    }
                })
        },
        confirmCancelDeliveryCountdownTimer() {
            if (this.confirmCancelDeliveryCountdown >= 0) {
                setTimeout(() => {
                    this.confirmCancelDeliveryCountdown -= 1
                    this.confirmCancelDeliveryCountdownTimer()
                }, 1000)
            } else {
                this.confirmCancelDeliveryCountdown = 'Odwołaj'
                this.cancelDeliveryButtonDisabled = false
            }
        },
        confirmCancelDelivery(item) {
            this.$set(item, 'cancelDeliveryClicked', true)
            // this.cancelDeliveryClicked = true
            this.cancelDeliveryButtonDisabled = true
            this.confirmCancelDeliveryCountdownTimer()
        },
        cancelDelivery(id) {
            this.$store.dispatch('deliveries/cancel', id).then(response => {
                if (response.status === 200) {
                    this.$emit('delivery-cancel')
                } else if (response.response.status === 406) {
                    this.errorMessage = true
                }
            })
        },
        fetchDelivery() {
            if (Object.prototype.hasOwnProperty.call(this.modalPayload, 'id')) {
                this.$store.dispatch(
                    'deliveries/fetchView',
                    this.modalPayload.id
                )
            }
        },
        moment(date) {
            return moment(date)
        },
        handleSubmitComplain(deliveryId) {
            const formData = new FormData()
            formData.append('delivery_id', deliveryId)
            formData.append('description', this.complaintContent)
            if (this.complaintFiles && this.complaintFiles.length) {
                Array.from(Array(this.complaintFiles.length).keys()).map(
                    fileIdx => {
                        formData.append(
                            `files[${fileIdx}]`,
                            this.complaintFiles[fileIdx]
                        )
                    }
                )
            }
            this.$store
                .dispatch('complaints/sendComplaint', formData)
                .then(response => {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: response,
                        name: 'complaint',
                        limit: 0
                    })
                    this.complaintFiles = []
                    this.complaintContent = ''
                    this.$refs.files.value = ''
                    this.showComplaint = false
                })
                .catch(error => {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: error,
                        name: 'complaint',
                        limit: 0
                    })
                })
        }
    },
    mounted() {
        this.fetchDelivery()
        this.$store.dispatch('resetWeekCart')
    }
}
</script>
